import "./AdminMain.css";

import React, { useRef } from "react";

import { AdminMode } from "../Admin";
import { api } from "../../../api/api";
import { useNavigate } from "react-router-dom";

const modes: { name: string; mode: AdminMode; icon: string }[] = [
  { name: "Users", mode: "users", icon: "users" },
  { name: "Courses", mode: "courses", icon: "book" },
  { name: "Proficiency Tests", mode: "exams", icon: "question" },
  { name: "Workspaces", mode: "workspaces", icon: "briefcase" },
  { name: "Buckets", mode: "buckets", icon: "shopping-basket" },
  { name: "Orders", mode: "orders", icon: "balance-scale" },
  { name: "Logs", mode: "logs", icon: "list" },
];

export default function Main() {
  const navigate = useNavigate();
  const [message, setMessage] = React.useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onGotoPage = (mode: AdminMode) => {
    navigate(`/admins/${mode}`); // Navigate to the selected mode
  };

  const onActionClick = async (dump: "courses" | "questions" | "sections") => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current); // Clear previous timeout if it exists
    }
    setMessage("Busy..."); // Clear previous message
    switch (dump) {
      case "courses":
        // await api.admin.dump.courses();
        setMessage((await api.admin.dump.courses()).data);
        break;
      case "questions":
        setMessage((await api.admin.dump.questions()).data);
        break;
      case "sections":
        setMessage((await api.admin.dump.sections()).data);
        break;
      default:
        setMessage("Invalid action");
        break;
    }
    timeoutRef.current = setTimeout(() => {
      setMessage(null); // Clear message after 5 seconds
    }, 5000);
  };

  return (
    <div className="admin-main">
      <ul className="admin-menu">
        {modes.map((m, i) => (
          <li key={i} onClick={() => onGotoPage(m.mode)}>
            <i className={`fa fa-${m.icon}`}></i> <span>{m.name}</span>
          </li>
        ))}
      </ul>
      <div className="admin-actions-container">
        <div className="admin-actions">
          <button onClick={() => onActionClick("courses")}>Dump Courses</button>
          <button onClick={() => onActionClick("questions")}>
            Dump Questions
          </button>
          <button onClick={() => onActionClick("sections")}>
            Dump Sections
          </button>
        </div>
        <div className="admin-message">
          {message && <div className="admin-message-text">{message}</div>}
        </div>
      </div>
    </div>
  );
}
